import { lazy } from 'react';
import PageView from './PageView';

const SubscriptionPage = lazy(() => import('src/pages/subscription'));

export const subscriptionRoutes = [
  {
    path: 'subscription',
    element: <PageView permission="BO_CAN_VIEW_SUBSCRIPTIONS" />,
    children: [{ element: <SubscriptionPage />, index: true }],
  },
];
